// @flow
import * as React from 'react';
import { hydrate } from 'react-dom';
import Default from '../default';
import ErrorPage from './layout';
import ClientProvider from '../ClientProvider';
import {dropdownLangsPossibilitiesRegex, URLS} from '../../utils/const';
import {isSupportedMobile, isStagingEnv} from '../../utils';


class ErrorPageLayout extends Default {
    constructor(reducers: Array<string>, sagas: Array<string>, layout: Function | React.ComponentType<any>) {
        super(reducers, sagas, layout);
    }

    render(container: ?Object): any {
        const basename = location.pathname.replace(URLS.EXCEPT_MODALS_REGEX, '').replace(dropdownLangsPossibilitiesRegex, '');
        const data = window.__WOT__.data;

        return hydrate(
            <ClientProvider basename={basename ? basename[0] : '/'} store={this.store}>
                <ErrorPage title={data.errorTitle} target={data.errorTarget} isMobileUser={isSupportedMobile()}/>
            </ClientProvider>, container || this.container);
    }
}

const app = new ErrorPageLayout(['lastAction'], [], ErrorPage);

app.render();

if (isStagingEnv()) {
    window.app = app;
}
